<template>
  <li class="nav-item dropdown">
    <a
      class="nav-link dropdown-toggle"
      href="#"
      id="navbarLang"
      role="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      :aria-expanded="expanded ? 'true' : 'false'"
      @click.prevent="expanded = !expanded"
      v-click-outside="collapseDropdown"
    >
      {{ $t("language") }}
    </a>
    <div
      :class="['dropdown-menu dropdown-menu-right', { show: expanded }]"
      aria-labelledby="navbarLang"
    >
      <a
        class="dropdown-item"
        v-for="lang in $i18n.availableLocales"
        :key="lang"
        @click="selectLanguage(lang)"
        >{{ $t("language", lang) }}</a
      >
    </div>
  </li>
</template>

<script>
import { mapMutations } from "vuex";
import { updateTitle } from "./../tools";

export default {
  name: "LanguageSwitch",
  data() {
    return {
      expanded: false
    };
  },
  methods: {
    ...mapMutations(["changeLanguage"]),
    selectLanguage(lang) {
      this.expanded = false;
      this.changeLanguage(lang);
      updateTitle(this.$router.currentRoute);
    },
    collapseDropdown() {
      this.expanded = false;
    }
  }
};
</script>

<style scoped lang="scss">
.dropdown-toggle {
  min-width: 3.6em;
}
</style>
